import state from './moduleNationalityState.js'
import mutations from './moduleNationalityMutations.js'
import actions from './moduleNationalityActions.js'
import getters from './moduleNationalityGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
